

export class DataSourceOptionMetadataBase {

    id: string = "option" + Math.floor(Math.random() * 1000000)
    value: string = this.id

    constructor() {}

}

export interface DataSourceOptionMetadata extends DataSourceOptionMetadataBase { }